import routerOptions0 from "/Users/fbonin/IdeaProjects/lotto-qc/github/org-rd-fullstack-springboot-nuxt/src/frontend/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}